import React, { useState } from "react";
import "./css/about.css";

const About = () => {
  const [activeMenu, setActiveMenu] = useState("main-skills");
  const [activeContent, setActiveContent] = useState("");
  const menuItems = [
    { 
      id: "main-skills", 
      title: "Main skills", 
      content: (
        <div>
        <p>As a software developer, data scientist and machine learning expert, I possess a range of common skills that enable me to excel in each of these areas. Some of these skills include:</p>
        <ul>
          <li>Proficiency in programming languages such as Python, Javascript, ReactJS and Ruby on Rails</li>
          <li>Experience in software development and knowledge of software development principles</li>
          <li>Strong problem-solving skills and analytical abilities</li>
          <li>Understanding of statistics, data structures, and algorithms</li>
          <li>Ability to work with large datasets and manipulate data</li>
          <li>Experience with data visualization tools and techniques</li>
          <li>Familiarity with machine learning algorithms and frameworks</li>
          <li>Excellent communication and teamwork skills to collaborate with others effectively</li>
        </ul>
      </div>
      )
    },
    // { id: "awards", title: "Awards", content: "Suspendisse tincidunt metus sit amet nibh accumsan, eu pretium velit tincidunt. Aenean posuere velit in lacinia efficitur." },
    { id: "experience", title: "Languages", content: (
      <div>
      <p>I have learnt the following languages and frameworks:</p>
      <ul>
        <li>Javascript</li>
        <li>ReactJS</li>
        <li>Ruby on Rails</li>
        <li>NodeJs</li>
        <li>Python</li>
        <li>Html</li>
        <li>Css</li>
        <li>Tailwind Css</li>
      </ul>
    </div>
    ) },
    { id: "education-certification", title: "Education & Certification", content: (
      <div>
        <p>Educational Background:</p>
        <ul>
        <li>Moringa School :Fullstack Web Developer</li>
        <li>International Association for Business Analytics Certification (IABAC):Machine learning</li>
        <li>African Center For Data Science:Data Science</li>
        <li>African Center For Data Science:Machine Learning</li>
        <li>Data to Information College: Diploma Computer Science</li>
        </ul>
      </div>
    ) },
  ];

  const handleClick = (id) => {
    setActiveMenu(id);
    const content = menuItems.find((item) => item.id === id)?.content;
    setActiveContent(content || "");
  };

  return (
    <section id="about">
    <div className="about-container">
      
      <h2>About Me</h2>
     <p> As a software developer, I bring a diverse set of skills and interests to any development team. With a background in data science, I am equipped with technical expertise,an analytical mindset and creativity to tackle complex problems.</p>
<p>Staying up-to-date with the latest industry trends and technologies is crucial , and I thrive in fast-paced, collaborative environments. Whether it's working on a data science project or developing a new software application, committed to delivering high-quality work that exceeds expectations and drives results.</p>
<p>I am a highly motivated and enthusiastic team player who is passionate about using technology to drive innovation and positive change. I believe that I can make a valuable contribution to any development team and am excited to take on new challenges in the field.</p>
      <div className="menu-container">
        {menuItems.map((item) => (
          <div
            key={item.id}
            className={`menu-item ${activeMenu === item.id ? "active" : ""}`}
            onClick={() => handleClick(item.id)}
          >
            {item.title}
          </div>
        ))}
      </div>
      <div className="content-container">
        <div className={`content-item ${activeMenu ? "active" : ""}`}>
          <p>{activeContent}</p>
        </div>
      </div>
    </div>
    </section>
  );
};

export default About;
